import { apartmentsApi } from '../api/apartmentsApi';

export async function fetchApartmentFeeNoticeHtml(
  apartmentId: string,
  options?: { detailed?: boolean },
): Promise<string> {
  return apartmentsApi.fetchApartmentFeeNoticePreviewHtml(apartmentId, options);
}

export function printApartmentFeeNoticeHtml(html: string): void {
  const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const printWindow = window.open(url, '_blank');
  if (!printWindow) {
    URL.revokeObjectURL(url);
    return;
  }
  printWindow.addEventListener('load', () => {
    URL.revokeObjectURL(url);
    printWindow.focus();
    printWindow.print();
  });
}
